module.exports = __webpack_public_path__ + "media/assets/player/pause-67138f22b2208861c2b377b6d5ef5d77.svg";